import type { CategoryMeta } from "../types/video";

export const categories: CategoryMeta[] = [
  {
    key: "comedy",
    slug: "comedy",
    name: "搞笑",
    icon: "ri-emotion-laugh-line",
    description: "把一天的疲惫都笑没，沙雕脑洞、生活包袱、萌宠翻车，快乐浓度拉满。",
  },
  {
    key: "entertainment",
    slug: "entertainment",
    name: "娱乐",
    icon: "ri-star-smile-line",
    description: "舞台高光、综艺名场面、影视混剪，一键围观当下最热的娱乐话题。",
  },
  {
    key: "life",
    slug: "life",
    name: "生活",
    icon: "ri-plant-line",
    description: "出租屋改造、独居日常、Citywalk 路线，认真记录闪闪发光的小日子。",
  },
  {
    key: "food",
    slug: "food",
    name: "美食",
    icon: "ri-restaurant-2-line",
    description: "深夜里的一碗热汤、复刻街边小吃的快乐，跟着镜头一起吃得满足。",
  },
];